import * as React from 'react';

var PopoverTrigger = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var popoverId = _ref.popoverId,
    showing = _ref.showing,
    togglePopover = _ref.togglePopover,
    trigger = _ref.trigger;
  return /*#__PURE__*/React.cloneElement(trigger, {
    "aria-controls": showing ? popoverId : void 0,
    "aria-expanded": showing,
    "aria-haspopup": "dialog",
    onClick: function onClick() {
      return togglePopover();
    },
    ref: ref,
    role: "button"
  });
});
PopoverTrigger.displayName = "PopoverTrigger";

export { PopoverTrigger };
